import React from "react";
import noop from "lodash/noop";
import cn from "classnames";
import { Slider, Rail, Handles, Tracks } from "react-compound-slider";
import Handle from "./Handle";
import Track from "./Track";
import styles from "./style.module.scss";

interface IProps {
  minValue: number;
  maxValue: number;
  step?: number;
  className?: string;
  onChange?: () => void;
  onUpdate?: () => void;
  leftHandleValue?: number;
  rightHandleValue?: number;
}

const SliderComponent = ({
  minValue,
  maxValue,
  step = 1,
  className = "",
  onChange = noop,
  onUpdate = noop,
  ...otherProps
}: IProps) => {
  const { leftHandleValue = minValue, rightHandleValue = maxValue } =
    otherProps;
  return (
    <Slider
      className={cn(styles.slider, className)}
      domain={[minValue, maxValue]}
      values={[leftHandleValue, rightHandleValue]}
      step={step}
      mode={2}
      onChange={onChange}
      onUpdate={onUpdate}
    >
      <Rail>
        {({ getRailProps }) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <div className={styles.rail} {...getRailProps()} />
        )}
      </Rail>
      <Handles>
        {({ handles, getHandleProps }) => (
          <div className="slider-handles">
            {handles.map((handle) => (
              <Handle
                key={handle.id}
                handle={handle}
                getHandleProps={getHandleProps}
              />
            ))}
          </div>
        )}
      </Handles>
      <Tracks right={false} left={false}>
        {({ tracks, getTrackProps }) => (
          <div className="slider-tracks">
            {tracks.map(({ id, source, target }) => (
              <Track
                key={id}
                source={source}
                target={target}
                getTrackProps={getTrackProps}
              />
            ))}
          </div>
        )}
      </Tracks>
    </Slider>
  );
};

export default SliderComponent;
